/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store'
import { App } from './App'
import Layout from './components/Layout/Layout'
import "@fontsource/maven-pro"
import * as serviceWorker from './serviceWorker'
import { ThemeProvider } from '@mui/material/styles';

import themes from './themes';

const customization = {
    borderRadius: 12,
    fontFamily: "'Roboto', sans-serif",
    locale: "en",
    mode: "dark",
};


ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter >


            <ThemeProvider theme={themes(customization)} >

                <Layout>

                    <App />

                </Layout>

            </ThemeProvider>

    </BrowserRouter>
    </Provider >,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
